$(document).ready(function() {
	
	$('select').each(function() {
		$(this).change(function () {
			if ($(this).val() == "") {
				$(this).addClass("empty");
			} else { 
				$(this).removeClass("empty");
			}
		});
	})

	$("select").change();


	$(window).on('scroll', function() {
		if ($(this).scrollTop() > 600 && $(window).width() >= 600) {
			$('#toTopBtn').fadeIn();
		} else {
			$('#toTopBtn').fadeOut();
		}
	});

	$('#toTopBtn').on('click', function() {
		$("html, body").animate({
			scrollTop: 0
		}, 0);
		return false;
	});

	$(window).on('resize', function() {
		if ($(window).width() < 600) {
			$('#toTopBtn').fadeOut();
		} else if ($(window).scrollTop() > 600) {
			$('#toTopBtn').fadeIn();
		}
	});

	$('[data-link]').on('click', function(e) {
		window.location = $(this).data('link');
	});
});